import { connect } from 'react-redux';
import { getSubCategory } from 'common/ducks/categories';
import { isProjectTagline } from 'project/utils';
import BottomNavGuarantee from 'pap/components/common/bottom_nav_guarantee';

const mapStateToProps = ({ categories }, { subCategorySlug }) => {
  const subCategory = getSubCategory(categories, subCategorySlug);
  let details;
  if (!subCategory || subCategory.entry_type === "image") {
    details = "A design you love or 100% of your money back.";
  } else if (isProjectTagline({ sub_category: subCategory.id })) {
    details = "If you get fewer than 100 taglines, get 100% of your money back.";
  } else {
    details = "If you get fewer than 100 names, get 100% of your money back.";
  }

  return {
    details
  }
}

export default connect(mapStateToProps)(BottomNavGuarantee);



// WEBPACK FOOTER //
// ./pap/containers/common/bottom_nav_guarantee.js